<app-generic-form [title]="title" [showBorder]="false">
  <form [formGroup]="addGameForm" (ngSubmit)="onSubmit()" form-content>
    <div>
      <label for="gameName" class="form-label">Nome del Gioco</label>
      <input type="text" formControlName="gameName" id="gameName" class="form-control" required>
    </div>
    <div>
      <label for="gameDescription" class="form-label">Descrizione</label>
      <textarea formControlName="gameDescription" id="gameDescription" class="form-control" required></textarea>
    </div>
    <div>
      <label for="gameType" class="form-label">Tipo di Gioco</label>
      <select formControlName="gameType" id="gameType" class="form-select" required>
        <option value="RPG">RPG</option>
        <option value="TTG">TTG</option>
        <option value="MIXED">MIXED</option>
        <option value="GENERIC">GENERIC</option>
      </select>
    </div>
    <div>
      <label for="minPlayers" class="form-label">Giocatori minimi:</label>
      <input type="number" formControlName="minPlayers" id="minPlayers" min="1" class="form-control" required>
    </div>
    <div>
      <label for="maxPlayers" class="form-label">Giocatori Massimi</label>
      <input type="number" formControlName="maxPlayers" id="maxPlayers" min="1" class="form-control" required>
    </div>

    <hr class="my-3">
    <h6 class="text-muted mb-2">Dati BGG (opzionali)</h6>
    <div>
      <label for="yearPublished" class="form-label">Anno pubblicazione</label>
      <input type="number" formControlName="yearPublished" id="yearPublished" class="form-control" placeholder="Es. 2015">
    </div>
    <div>
      <label for="playingTime" class="form-label">Durata (minuti)</label>
      <input type="number" formControlName="playingTime" id="playingTime" class="form-control" placeholder="Es. 60">
    </div>
    <div>
      <label for="minAge" class="form-label">Età minima</label>
      <input type="number" formControlName="minAge" id="minAge" class="form-control" placeholder="Es. 8">
    </div>
    <div>
      <label for="imageUrl" class="form-label">URL immagine</label>
      <input type="text" formControlName="imageUrl" id="imageUrl" class="form-control" placeholder="https://...">
    </div>
    <div>
      <label for="thumbnailUrl" class="form-label">URL thumbnail</label>
      <input type="text" formControlName="thumbnailUrl" id="thumbnailUrl" class="form-control" placeholder="https://...">
    </div>

    @if (showCancel) {
      <div class="d-flex gap-2 mt-4">
        <button type="button" class="btn btn-secondary flex-grow-1" (click)="onCancel()">
          <i class="bi bi-x-lg me-1" aria-hidden="true"></i>Annulla
        </button>
        <button type="submit" class="btn btn-primary flex-grow-1" [disabled]="addGameForm.invalid">
          <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Gioco
        </button>
      </div>
    } @else {
      <button type="submit" class="btn btn-primary w-100 mt-4" [disabled]="addGameForm.invalid">
        <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Gioco
      </button>
    }
  </form>
</app-generic-form>
